import React, {useContext, useEffect} from "react";
import { Table, Empty, Button } from "antd";
import { useLanding } from "../../../hooks/useLanding";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {TemplateContext} from "../../../utils/template_context";

export const GestionarJurados = () => {
  const { principalState, getConvocatorias } = useLanding();

    const context = useContext(TemplateContext);
  //   cargar jurados
  useEffect(() => {
    getConvocatorias();
  }, []);
  const columns: any = [
    {
      title: "No.",
      width: 80,
      render: (datos: any, datos2: any, index: number) => <span>{index}</span>,
      fixed: context.device === "md"? "left": false,
    },
    {
      title: "Nombre convocatoria",
      width: 200,
      fixed: context.device === "md"? "left": false,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
    },
    {
      title: "Cobertura",
      width: 120,
      dataIndex: "cobertura",
      key: "cobertura",
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
          <div className="col-4 font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg"? "right": false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-4">
            <Button className="button-gray-ghost" icon={<EyeOutlined />}></Button>
          </div>
          <div className="col-4">
            <Button className="button-gray-ghost" icon={<EditOutlined />}></Button>
          </div>
          <div className="col-4">
            <Button className="button-gray-ghost color-delete" icon={<DeleteOutlined />}></Button>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div className="background-color-F7FBFF h-100">
      <div className="container-fluid ps-md-4 pe-md-4 main-c6">
        <div className="row-shadow row mt-3 mb-3 ">
          <div className="col-12 font-size-14px font-family-Montserrat-SemiBold" style={{ paddingBottom: "2%" }}>
            {" "}
            Gestionar convocatorias jurados
          </div>
          <div className="col-12">
            <Table
              locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
              dataSource={principalState.todaslasconvocatorias.filter((data: any) => data.tipo === "2")}
              columns={columns}
              size="large"
              bordered={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
